import { createSelector } from 'reselect';

import { getUserProfile, User } from '@topconagriculture/profiling';

import { RootState } from '../../reducers';
import { Farm, FarmType } from './farms.types';
import { getCurrentFarmId, getSelectedCompanyId } from '../../selected/selected.selector';
import { SharingRoles } from '../../../core/api/sharing/sharing.types';

export const getFarms = (state: RootState): Farm[] => state.entities.farms;

export const getFarmId = (state: RootState): string | null =>
  state.entities.farms ? state.entities.farms[0].id : null;

export const getFarmsOfSelectedCompany = createSelector(
  [getFarms, getSelectedCompanyId],
  (farmList: Farm[], companyId: string) =>
    companyId ? farmList.filter((farm) => farm.companyId === companyId) : farmList,
);

export const hasFarms = createSelector(getFarmsOfSelectedCompany, (farmList): boolean => !!farmList.length);

export const getSelectedFarm = createSelector([getFarms, getCurrentFarmId], (farmList, currentFarmId) =>
  farmList.find((farm) => farm.id === currentFarmId),
);

export const isSharedFarm = createSelector([getSelectedFarm], (farm): boolean | undefined => farm && farm.sharedAccess);

export const canAccessThroughSharing = createSelector(
  [getSelectedFarm, isSharedFarm],
  (farm: Farm, isShared: boolean) => (isShared ? farm.sharedAccessLevel === SharingRoles.ADMIN : true),
);

export const isOwnFarmSelected = createSelector(
  [getFarms, getCurrentFarmId, getUserProfile],
  (farms: Farm[], id: string | null, user: User | null) => {
    return farms?.filter((farm) => farm.companyId === user?.company.id).some((farm) => farm.id === id);
  },
);

export const isCurrentFarmBeef = createSelector([getSelectedFarm], (farm) => farm && farm.farmType === FarmType.BEEF);
export const isCurrentFarmDairy = createSelector([getSelectedFarm], (farm) => farm && farm.farmType === FarmType.DAIRY);
export const isCurrentFarmTypeNotSet = createSelector([getSelectedFarm], (farm) =>
  !farm ? false : farm.farmType !== FarmType.DAIRY && farm.farmType !== FarmType.BEEF,
);
